export default __webpack_public_path__ + "static/media/ranes15.0f62c01f.jpg";